export const DEFAULT_PROFILE_SETTINGS = {
  incorrectHelpThreshold: 3,
};

export const MIN_INCORRECT_HELP_THRESHOLD = 1;
export const MAX_INCORRECT_HELP_THRESHOLD = 10;
